<div class="chat bg-gray-dark shadow-sm hover-shadow transition-fast rounded-lg mb-5 overflow-hidden">
  <div class="container p-5 px-0 px-lg-4 py-lg-4 h-100">
    <!-- No Messages -->
    <ng-container *ngIf="isLoading">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <div>
          <div class="spinner-grow" style="width: 2rem; height: 2rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <h6 class="text-muted"><small>جاري تحميل الرسائل...</small></h6>
        </div>
      </div>
    </ng-container>
    

<!-- Chat Messages -->
<ng-container *ngIf="!isLoading">
<div class="row">
<div class="col-12 text-start">
  <h4 class="font-weight-bold text-center text-lg-start mb-4 d-flex align-items-center">
    <!-- Back Button -->
    <button (click)="goBack()" class="back-btn me-3">
      <i class="bi bi-arrow-right-short"></i> <!-- Bootstrap Short Left Arrow -->
    </button>
  
    <!-- Ticket ID -->
    <span title="الرقم المميز لتذكرة الدعم الفني">#{{ selectedTicket?.id }}</span>
  </h4>
  </div>

<div class="col-12">
<div class="position-relative" style="height: 70vh;">
<!-- Messages Container -->
<div class="chat-messages-container" #messagesContainer (scroll)="onScroll()">
<div class="container-fluid">
  <div class="row flex-column">
    <ng-container *ngFor="let group of groupedMessages">
      
      <!-- Date Separator (Only one per date) -->
      <div class="col-12 text-center my-3">
        <span class="badge bg-secondary">{{ group.date }}</span>
      </div>

      <!-- Messages for this Date -->
      <ng-container *ngFor="let msg of group.messages">
        <div class="col-12">
          <div class="d-flex message-container"
               [ngClass]="msg.manager_id ? 'justify-content-end' : 'justify-content-start'">
            
            <!-- User Profile Image (Left) -->
            <div class="message-avatar" *ngIf="!msg.manager_id">
              <img src="assets/img/profile_picture.png" 
                   class="img-fluid rounded-circle hover-shadow" 
                   width="45" alt="المستخدم"/>
            </div>

            <!-- Message Box -->
            <div class="message-box"
                 [ngClass]="msg.manager_id ? 'manager-message' : 'user-message'">
              <div class="message-text">
                <h6 class="mb-1">{{ msg.message }}</h6>
                <small class="text-muted d-block text-end">{{ formatTime(msg.created_at) }}</small>
              </div>
            </div>

            <!-- Manager Profile Image (Right) -->
            <div class="message-avatar" *ngIf="msg.manager_id">
              <img src="assets/img/alofoq_logo_icon_square.png" 
                   class="img-fluid rounded-circle hover-shadow" 
                   width="45" alt="مدير الدعم"/>
            </div>

          </div>
        </div>
      </ng-container>

    </ng-container>
  </div>
</div>
</div>
    
<!-- Send Message Input -->
<div class="overflow-y-auto position-absolute custom-scroll w-100 d-flex align-items-center" style="bottom: 0; height: 25%">
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="input-group hover-shadow mt-4" style="border-radius: 15px;">
        
        <!-- Message Input -->
        <input type="text" #messageInput class="form-control border-end-0 py-3"
        placeholder="اكتب رسالة ..." style="border-radius: 0 15px 15px 0;"
        (keydown.enter)="sendMessageOnEnter(messageInput)"
        (keyup.enter)="$event.preventDefault()">
         
        <!-- Send Button -->
        <span class="input-group-text bg-white" style="border-radius: 15px 0 0 15px;">
          <button class="btn btn-sm btn-success-light hover-shadow transition-fast px-3 pt-0 rounded-3 text-light" 
                  type="button"
                  (click)="sendMessage(messageInput.value); messageInput.value = ''">
            إرسال
          </button>
        </span>

      </div>
    </div>
  </div>
</div>
</div>
<!-- End Message Input -->
</div>
</div>
</div>
</ng-container>

  </div>
</div>
